// Fill these in later; anything left null/false stays hidden on the site.
export const SITE_URL = "https://atlasbridge.global";

export const SITE = {
  phone: null,
  phoneHref: null,
  whatsapp: null,
  whatsappHref: null,
  emailDomain: "atlaslogisticsbridge.com",
  emailsLive: true,
  emails: ["info", "support", "sales", "ops", "docs"],
  crNo: null,
  licNo: null,
};

export const emailOf = (box) => `${box}@${SITE.emailDomain}`;
